<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <p class="mb-0">
              Para que una inscripción pueda ser seleccionada, debe cumplir ciertos criterios de estado.
              <v-btn small text color="primary" @click="abrirCriterios">
                <v-icon small left>mdi-information-outline</v-icon>
                Ver criterios
              </v-btn>
            </p>

            <ModalCriteriosInscripciones ref="modalCriteriosRef" />
          </v-col>

          <v-col cols="12">
            <div class="d-inline-block" style="max-width: 300px">
              <v-select
                v-model="estadoInscripcion"
                :items="[
                  { text: 'Todos', value: null },
                  { text: 'Preinscrito', value: estadosInscripcionesEnum.PREINSCRITO },
                  { text: 'Inscrito', value: estadosInscripcionesEnum.INSCRITO },
                  { text: 'Retirado', value: estadosInscripcionesEnum.RETIRADO },
                  { text: 'Cambiado', value: estadosInscripcionesEnum.CAMBIADO },
                  { text: 'Congelado', value: estadosInscripcionesEnum.CONGELADO },
                ]"
                label="Estado inscripción"
                outlined
                dense
                hide-details
                @change="listar"></v-select>
            </div>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoInscripciones
              ref="listadoRef"
              :items="itemsFiltradosPorProgramaId"
              :cargando="cargando"
              :itemsYaSeleccionados="itemsYaSeleccionados"
              :universidadId="universidadId"
              @selectItem="selectItem" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando || itemsSeleccionados.length == 0"
          :loading="enviando"
          @click.prevent="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import layoutMixin from '../mixins/layout.mixin';
import ListadoInscripciones from './ListadoInscripciones.vue';
import ModalCriteriosInscripciones from './ModalCriteriosInscripciones.vue';
import InscripcionesService from '../services/inscripcion.service';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import { ESTADOS_INCRIPCIONES_ENUM, ESTADOS_INSCRIPCION } from '../utils/constantes';
import { mapGetters } from 'vuex';
import { concatenar, formatearErrores } from '../utils/funciones';

export default {
  name: 'ModalFormularioInscripciones',
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoInscripciones,
    ModalCriteriosInscripciones,
  },
  props: {
    programaUniversidadId: {
      type: Number,
      required: true,
    },
    universidadId: {
      type: Number,
      default: null,
    },
    programaId: {
      type: Number,
      default: null,
    },
    itemsYaSeleccionados: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      itemsSeleccionados: [],
      estadoInscripcion: null,
      estadosInscripcionesEnum: ESTADOS_INCRIPCIONES_ENUM,
      estadosInscripcion: ESTADOS_INSCRIPCION,
    };
  },
  computed: {
    ...mapGetters('pago', ['getFiltrarPorSede']),
    itemsFiltradosPorProgramaId() {
      if (this.programaId) {
        return this.items.filter((item) => item.programaId === this.programaId);
      }

      return this.items;
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.itemsSeleccionados = [];
      this.listar();
    },
    listar() {
      this.items = [];

      const params = {
        programaUniversidadId: this.programaUniversidadId,
        estadoInscripcion: this.estadoInscripcion,
        sedeId: this.getFiltrarPorSede ? this.$store?.state?.cargo_sede?.sede?.id : null,
      };

      this.obtenerDatosConNotificacion(
        InscripcionesService.findAllPorProgramaUniversidadVerificacion,
        'items',
        this.nombreItem,
        params,
      );

      this.item = null;
    },
    abrirCriterios() {
      this.$refs.modalCriteriosRef.abrir();
    },
    selectItem(items) {
      this.itemsSeleccionados = items || [];
    },
    async guardar() {
      this.enviando = true;

      try {
        const response = await ProgramaUniversidadService.registrarInscripciones(this.programaUniversidadId, {
          realizadoPorId: this.$store.state.DATA_USER.id,
          realizadoPor: concatenar(
            this.$store.state.DATA_USER.nombres,
            this.$store.state.DATA_USER.pri_apellido,
            this.$store.state.DATA_USER.seg_apellido,
          ),
          inscripciones: this.itemsSeleccionados.map((item) => {
            return {
              inscripcionId: item.id,
              estado: ESTADOS_INSCRIPCION[item.estadoInscripcion].toLowerCase(),
            };
          }),
        });

        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });

        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso.toUpperCase()}`,
          text: erroresFormateados || mensaje || 'Ocurrió un error al registrar las inscripciones',
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>